export default "__VITE_ASSET__BOInX4YS__"